// The report a /reports/:id route means. The menu links by name (/reports/Outstanding Orders) and older
// links by number (/reports/3); the grouped table only tried the number, so grouping a report opened
// from the menu found no report and stopped (TypeError on reportEP).
export function reportIndexFor(allReports, routeId) {
  const list = allReports || []
  const id = parseInt(routeId)
  return list.findIndex(r => r && (r.reportName === routeId || (!isNaN(id) && String(id) === String(routeId) && r.id === id)))
}
